/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable max-len */
import {Icon} from '@adobe/react-spectrum';
import React from 'react';

const AIChat = (): JSX.Element => (
  <Icon>
    <svg height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="m15.51398.2286l-.36999,2.80207c-.03171.2402.04722.48182.21463.65695l1.78172,1.86402-2.57354-.16623c-.24172-.01561-.47749.07923-.64106.25788l-1.90874,2.08464.36673-2.80474c.03134-.23971-.04748-.48071-.21441-.65558l-1.77898-1.86354,2.57071.16539c.2413.01552.47666-.07901.64017-.25714L15.51398.2286Z" />
      <path d="m14.68176,6.59454l-1.77972,1.94373c-.23273.25415-.55615.38971-.88544.38971-.17108,0-.34375-.03662-.5061-.11218-.47467-.22101-.75128-.72424-.68341-1.24347l.34192-2.61469-1.64667-1.72498c-.31604-.33099-.40283-.80798-.24982-1.23267H2c-1.10455,0-2,.89539-2,2v7c0,1.10455.89545,2,2,2h1v4.39648c0,.13806.112.25.25006.24994.06641,0,.13007-.02643.17694-.07343l4.573-4.573h6c1.10455,0,2-.89545,2-2v-4.31989l-1.31824-.08557Zm-6.76929,3.71094c-.26855-.0174-.53052.08801-.71228.2865l-1.31805,1.43951.2533-1.93719c.03479-.2663-.0528-.53412-.23828-.72839l-1.21997-1.27802,1.76288.11346c.26813.01721.52966-.08783.7113-.28577l1.32111-1.43915-.25549,1.93494c-.03522.26685.05249.53534.23846.72992l1.22174,1.27814-1.76471-.11395Z" />
    </svg>
  </Icon>
);

export default AIChat;
